import { FC } from 'react';
import { AddressBookList } from './address-book-list';
import { IAddressBookData } from '../../../../../models';

interface IAddressBook {
  buildId: string;
  isLoading: boolean;
  addressBook: IAddressBookData[];
  refetchAddressBook: () => void;
}

export const AddressBook: FC<IAddressBook> = ({
  buildId,
  isLoading,
  addressBook,
  refetchAddressBook
}) => {
  return (
    <>
      <AddressBookList
        buildId={buildId}
        isLoading={isLoading}
        addressBook={addressBook}
        refetchAddressBook={refetchAddressBook}
      />
    </>
  );
};
